import { client } from "./_base";

const table = "consigneeclearingagent";
export const consigneeclearingagent = client(table, (item) => ({
  ...item,
}));